<template>
    <div class="channel-report">
        <div>
            <router-view :isCollapse="isCollapse"></router-view>
        </div>
    </div>
</template>

<script>
// import echarts from 'echarts';
// import roma from '../echartConfig/roma.json';

export default {
    name: 'Index', // router页面
    props: {
        isCollapse: {
            type: Boolean
        }
    }
    // created () {
    //     echarts.registerTheme('roma', roma);
    // }
};
</script>
<style lang="less" scoped></style>
